import React, { useContext, useEffect, useRef } from "react";
import { defaultModalProps, Modal } from "../ModalComponent/Modal";
import ModalDividerLine from "../ModalComponent/modal-divider-line";
import "./object-password-modal.css";
import { TrackObjectToken } from "../../../utils/genericUtils";
import { UserContext } from "../../../context/UserContext";
import { LoaderContext } from "../../../context/LoaderContext";
import { POST } from "../../../utils/httpUtils";

const defaultProps = {
  ...defaultModalProps,
  objectId: "",
  onUnlock: () => {},
};

export default function ObjectPasswordModal(props = defaultProps) {
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);

  const passwordInput = useRef();
  const error_message = useRef();

  useEffect(() => {}, []);

  function ShowErrorMessage() {
    if (error_message.current) {
      return <p className="error-message">*{error_message.current}</p>;
    }
  }

  /**
   * POST call to get an objectToken for a specified object
   * @param {*} objectId
   * @returns
   */
  async function UnlockObject(objectId) {
    if (!passwordInput.current || !objectId) return;
    showloader();
    let response = await POST("/unlock-object", { objectId, password: passwordInput.current.value }, user);
    hideloader();
    if (response.success && response.objectToken) {
      let token = response.objectToken;
      TrackObjectToken(objectId, token);

      //reset error
      error_message.current = undefined;

      //trigger callback for unlock
      if (props.onUnlock) props.onUnlock();
      //close the modal
      props.onCloseModal();
    } else {
      error_message.current = response.error.message ?? "Something Went Wrong";
    }
  }

  return (
    <Modal id={props.id} {...props} header={"Object Is Locked"} isActive={props.isActive} showDivider={true} animate={true}>
      {/* input */}
      <div className="input-box">
        <label htmlFor="">Object Password</label>
        <input ref={passwordInput} type="password" placeholder="enter object password" />
      </div>

      {ShowErrorMessage()}

      <ModalDividerLine showDivider={true}></ModalDividerLine>

      {/* controls */}
      <div className="confirmation-modal-buttons" style={{ marginTop: !props.includeCheckboxSafety ? "35px" : 0 }}>
        <button className={"standard-button"} onClick={props.onCloseModal}>
          Cancel
        </button>
        <button className="standard-button btn-green" onClick={() => UnlockObject(props.objectId)}>
          Unlock
        </button>
      </div>
    </Modal>
  );
}
